import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaginatedResponseInterface } from '@sport-activities/sdk';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { appConfig } from '~/app.config';
import { AdviceInterface } from '~/attendee/interfaces/advice.interface';
import { Advice } from '~/attendee/model/advice.model';
import { ADVICE_API_KEY, ADVICE_BASE_URL } from '~/core/core.module';
import { createHttpParams } from '~/core/helpers/create-http-params/create-http-params.helper';

import { HydraResponseInterface } from '~/attendee/interfaces/hydra/hydra-response.interface';

@Injectable()
export class AdviceService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(ADVICE_BASE_URL) protected readonly adviceUrl: string,
    @Inject(ADVICE_API_KEY) protected readonly adviceApiKey: string,
    private readonly translateService: TranslateService
  ) {}

  public get defaultParams(): {
    [header: string]: string | string[] | Record<string, boolean>;
  } {
    return {
      locale: this.translateService.currentLang.replace('-', '_'),
      sort: '-updated_date',
      items_per_page: appConfig.pagination.loadMore.desktop.toString(),
      content_type: appConfig.adviceContentTypeUuidCollection.join(','),
      fields: 'id,title,locale,summary,teaser_image,url',
      status: '1',
      exists: { url: true },
    };
  }

  public get headers(): { [header: string]: string | string[] } {
    return {
      'x-api-key': this.adviceApiKey,
      'Content-Type': 'application/ld+json',
    };
  }

  public getAdviceContents(params?: {
    dd_sports: string;
    items_per_page?: number;
    page: number;
  }): Observable<PaginatedResponseInterface<Advice>> {
    return this.httpClient
      .get<HydraResponseInterface<AdviceInterface>>(
        `${this.adviceUrl}/contents`,
        {
          headers: this.headers,
          params: createHttpParams({
            ...this.defaultParams,
            ...params,
          }),
        }
      )
      .pipe(
        map((response) => {
          return {
            total: response['hydra:totalItems'],
            items: response['hydra:member'].map(
              (content) =>
                new Advice({
                  ...content,
                  teaserImage: content.teaser_image,
                })
            ),
          };
        })
      );
  }
}
